function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTypescript = function SvgTypescript(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface6241922"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(35.686275%,75.294119%,74.509805%)",
      fillOpacity: 1
    },
    d: "M 1.199219 1.199219 L 1.199219 94.800781 L 94.800781 94.800781 L 94.800781 1.199219 Z M 56.664062 50.34375 L 45.648438 50.34375 L 45.648438 84.398438 L 36.773438 84.398438 L 36.773438 50.34375 L 25.988281 50.34375 L 25.988281 42.800781 L 56.664062 42.800781 Z M 58.390625 82.457031 L 58.390625 73.351562 C 58.390625 73.351562 63.359375 77.097656 69.332031 77.097656 C 75.300781 77.097656 75.066406 73.199219 75.066406 72.664062 C 75.066406 67 58.160156 67 58.160156 54.457031 C 58.160156 37.398438 82.792969 44.132812 82.792969 44.132812 L 82.488281 52.238281 C 82.488281 52.238281 78.359375 49.480469 73.6875 49.480469 C 69.023438 49.480469 67.339844 51.703125 67.339844 54.074219 C 67.339844 60.195312 84.398438 59.582031 84.398438 71.898438 C 84.398438 90.867188 58.390625 82.457031 58.390625 82.457031 Z M 58.390625 82.457031 "
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTypescript, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/typescript.87baa598.svg";
export { ForwardRef as ReactComponent };